import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    paddingY: '18px',
    px: '24px',
    backgroundColor: 'secondary.main',
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    mb: '16px',
    color: 'common.grey850',
  },
  rateContainer: {
    display: 'flex',
  },
  datesRange: {
    mt: '24px',
  },
  datesContainer: {
    mb: '16px',
  },
  dateContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  text: {
    fontSize: 14,
  },
  strikeContainer: {

  },
  strikedDates: {
    textDecorationLine: 'line-through',
  },
  newDates: {
    color: 'primary.main',
    fontWeight: '600',
    ml: '24px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
